import { render, staticRenderFns } from "./feed-header.vue?vue&type=template&id=c4e52e62&scoped=true&"
import script from "./feed-header.vue?vue&type=script&lang=js&"
export * from "./feed-header.vue?vue&type=script&lang=js&"
import style0 from "./feed-header.vue?vue&type=style&index=0&id=c4e52e62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e52e62",
  null
  
)

export default component.exports